import { Space as AntdSpace, SpaceProps as AntdSpaceProps } from "antd";
import { CMP_PREFIX } from "@/base/constant";

export interface SpaceProps extends AntdSpaceProps {}

export const spacePrefixCls = `${CMP_PREFIX}-space`;

export const Space = ({ ...props }: SpaceProps) => {
  return <AntdSpace {...props} />;
};

export const SpaceCompact = AntdSpace.Compact;
